import { render } from "./HumanMessageComponent.vue?vue&type=template&id=6439f31a&scoped=true"
import script from "./HumanMessageComponent.vue?vue&type=script&lang=js"
export * from "./HumanMessageComponent.vue?vue&type=script&lang=js"

import "./HumanMessageComponent.vue?vue&type=style&index=0&id=6439f31a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6439f31a"]])

export default __exports__